import React from 'react';
import { Select } from 'antd';

import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

import globalMessages from 'translations/messages';
import useFormatMessage from 'hooks/useFormatMessage';
import SurveyTitle from 'components/SurveyTitle';
import messages from './messages';

const QUERY = gql`
  query($id: ID!) {
    surveyGroup(id: $id) {
      id
      surveys { id title language languageName version primary }
    }
  }
`;

const SurveySelect = ({
  surveyGroupId,
  surveys,
  onChange,
  value,
  exclude = [],
  primary,
  ...rest
}) => {
  const $t = useFormatMessage();

  const { loading, data: { surveyGroup = {} } = {} } = useQuery(QUERY, {
    variables: { id: surveyGroupId },
    skip: !surveyGroupId || surveys?.length,
  });

  const surveyOptions = (surveys || surveyGroup?.surveys || []);

  return (
    <Select placeholder={$t(globalMessages.selectSurvey)} loading={loading} value={loading ? $t(messages.loading) : value} onChange={onChange} disabled={loading} {...rest}>
      {surveyOptions.filter(s => !exclude.includes(s.id) && (!primary || s.primary)).map(survey => (
        <Select.Option key={survey.id} value={survey.id}>
          <SurveyTitle survey={survey} />
        </Select.Option>
      ))}
    </Select>
  );
};

export default SurveySelect;
